import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Row, Col, notification, PageHeader, Card, Table, Spin } from 'antd'
import { getProductFabric } from '../../network/ProductFabrics'

const ViewProductFabrics = ({ history }) => {
  const { key } = useParams()
  const [loading, setLoading] = useState(true)
  const [ProductFabrics, setProductFabrics] = useState([])

  useEffect(() => {
    setLoading(true)
    getProductFabric(key)
      .then((data) => {
        console.log('data', data)
        const product = data.product
        if (product) {
          setProductFabrics(product)
        } else {
          notification.error({ message: 'Product  Fabric not found!' })
        }
        setLoading(false)
      })
      .catch((error) => {
        console.error('Failed to fetch product prices:', error)
        notification.error({ message: 'Error fetching product prices!' })
      })
  }, [key])

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    )
  }

  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => history.push('/product-fabrics')}
        title={`Fabrics for ${ProductFabrics?.label || 'Product'}`}
      />
      <Row style={{ padding: '24px' }}>
        <Col span={24}>
          <Card>
            <Table
              dataSource={ProductFabrics.fabrics || []}
              columns={[
                {
                  title: 'Fabric Key',
                  dataIndex: 'key',
                  key: 'key',
                  width: '40%',
                },
                {
                  title: 'Fabric Label',
                  dataIndex: 'label',
                  key: 'label',
                  width: '60%',
                },
              ]}
              pagination={false}
              rowKey="key"
              locale={{
                emptyText: 'No fabrics available for this product.',
              }}
            />
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default ViewProductFabrics
